import { setIsDealerUpdatingAddrAction } from '@/store/actions/dealer';
import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux'; 

const useCheckDealerProfile = () => {
  const [profileIncomplete, setProfileIncomplete] = useState(false);
  const dispatch = useDispatch();

  const isFieldMissing = useCallback((fields) => fields.some(field => !field), []);

  const checkDealerProfile = useCallback((response) => {
    const {
      dealer = {},
      last_name,
      first_name,
      email,
      phone_number,
      dealer_company = {},
      manufacturer = {}
    } = response || {};

    const {
      address1 = '',
      city = '',
      state = {},
      county = '',
      zip = ''
    } = dealer_company || {};

    const {
      address 
    }= dealer || {};

    const { id: stateId = '' } = state;
    const { id: companyId = '', phone: companyPhone = '', email: companyEmail = '' } = dealer_company || {};
    const { id: manufacturerId = '' } = manufacturer;

    const dealerAddressFields=address;
    const dealerCompanyAddressFields = [address1, city, stateId, zip,county];
    const profileFields = [first_name, last_name, email, phone_number, companyId, companyPhone, companyEmail,
    manufacturerId];

    const dealerAddressIncomplete = isFieldMissing(dealerCompanyAddressFields);   
    const isProfileIncomplete = isFieldMissing(profileFields) || dealerAddressIncomplete||!dealerAddressFields;  

    if (isProfileIncomplete) {
        dispatch(setIsDealerUpdatingAddrAction(true)); 
    }
    else{
        dispatch(setIsDealerUpdatingAddrAction(false)); 
    }

    setProfileIncomplete(isProfileIncomplete);
  }, [dispatch, isFieldMissing]);

  return { profileIncomplete, checkDealerProfile };
};

export default useCheckDealerProfile;
